<template>
  <main class="p-5">
    <div class="container">
      <div class="row">
        <div class="col-12 m-0 no-max-w home-div">
          <h1>Text Editor</h1>
          <label class="pb-3" for="">Metinleri HTML formatında kopyalama işlemi yapılabilir.</label>
          <FormTextEditor v-model="editorContent" />
          <div ref="buttonPlaceholder" class="button-placeholder"></div>
        </div>
      </div>
    </div>
    <div
        class="fixed-copy-button"
        :class="{ 'is-bottom': isAtBottom }"
    >
      <label>Metin HTML formatında kopyalanabilir.</label>
      <button @click="copyToClipboard" class="btn btn-primary w-25">
        Copy
      </button>
    </div>
  </main>
</template>


<script>
export default {
  data() {
    return {
      editorContent: "",
      isAtBottom: false
    };
  },
  methods: {
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.editorContent);
        this.$swal
            .fire({
              text: "İçerik panoya kopyalandı.",
              icon: "success",
              customClass: {
                container: "my-sweet",
              },
              confirmButtonText: this.$t("global.ok"),
              allowOutsideClick: true,
            })
      } catch (err) {
        this.$swal.fire({
          text: "Kopyalama başarısız oldu.",
          icon: "error",
          customClass: {
            container: "my-sweet",
          },
          confirmButtonText: this.$t("global.ok"),
        });
      }
    },
    handleScroll() {
      const placeholder = this.$refs.buttonPlaceholder;
      if (!placeholder) return;

      const rect = placeholder.getBoundingClientRect();
      this.isAtBottom = rect.top <= window.innerHeight;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>


<style scoped>
.fixed-copy-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: white;
  border-top: 1px solid #ddd;
  z-index: 999;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;
}

.fixed-copy-button.is-bottom {
  position: static;
  box-shadow: none;
  border-top: none;
  padding: 0;
}

.button-placeholder {
  height: 80px; /* Buton yüksekliği kadar boşluk bırakılır */
}
</style>
